/**
 * Defines the constants used by the UI module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */
export const VUEX_UI_SHOW_NAVIGATION_DRAWER        = 'VUEX_UI_SHOW_NAVIGATION_DRAWER'
export const VUEX_UI_HIDE_NAVIGATION_DRAWER        = 'VUEX_UI_HIDE_NAVIGATION_DRAWER'
export const VUEX_UI_SHOW_LEFT_DRAWER              = 'VUEX_UI_SHOW_LEFT_DRAWER'
export const VUEX_UI_HIDE_LEFT_DRAWER              = 'VUEX_UI_HIDE_LEFT_DRAWER'
export const VUEX_UI_SHOW_RIGHT_DRAWER             = 'VUEX_UI_SHOW_RIGHT_DRAWER'
export const VUEX_UI_HIDE_RIGHT_DRAWER             = 'VUEX_UI_HIDE_RIGHT_DRAWER'
export const VUEX_UI_SHOW_ABSENCES_FILTER          = 'VUEX_UI_SHOW_ABSENCES_FILTER'
export const VUEX_UI_HIDE_ABSENCES_FILTER          = 'VUEX_UI_HIDE_ABSENCES_FILTER'
export const VUEX_UI_SHOW_JOB_FILTER               = 'VUEX_UI_SHOW_JOB_FILTER'
export const VUEX_UI_HIDE_JOB_FILTER               = 'VUEX_UI_HIDE_JOB_FILTER'

export const VUEX_UI_SHOW_JOB_SEARCH               = 'VUEX_UI_SHOW_JOB_SEARCH'
export const VUEX_UI_HIDE_JOB_SEARCH               = 'VUEX_UI_HIDE_JOB_SEARCH'
export const VUEX_UI_SHOW_JOB_SEARCH_MOBILE        = 'VUEX_UI_SHOW_JOB_SEARCH_MOBILE'
export const VUEX_UI_HIDE_JOB_SEARCH_MOBILE        = 'VUEX_UI_HIDE_JOB_SEARCH_MOBILE'

export const VUEX_UI_HIDE_JOB_CREATE               = 'VUEX_UI_HIDE_JOB_CREATE'
export const VUEX_UI_SHOW_JOB_CREATE               = 'VUEX_UI_SHOW_JOB_CREATE'

export const VUEX_UI_SHOW_OVERLAY                  = 'VUEX_UI_SHOW_OVERLAY'
export const VUEX_UI_HIDE_OVERLAY                  = 'VUEX_UI_HIDE_OVERLAY'
export const VUEX_UI_HIDE_ALL                      = 'VUEX_UI_HIDE_ALL'
export const VUEX_UI_HIDE_RESET_PASSWORD_OVERLAY   = 'VUEX_UI_HIDE_RESET_PASSWORD_OVERLAY'
export const VUEX_UI_SHOW_RESET_PASSWORD_OVERLAY   = 'VUEX_UI_SHOW_RESET_PASSWORD_OVERLAY'
export const VUEX_UI_SHOW_USER_FILTER              = 'VUEX_UI_SHOW_USER_FILTER'
export const VUEX_UI_HIDE_USER_FILTER              = 'VUEX_UI_HIDE_USER_FILTER'
export const VUEX_UI_SHOW_USER_OVERLAY             = 'VUEX_UI_SHOW_USER_OVERLAY'
export const VUEX_UI_HIDE_USER_OVERLAY             = 'VUEX_UI_HIDE_USER_OVERLAY'

export const VUEX_UI_SHOW_USER_SEARCH              = 'VUEX_UI_SHOW_USER_SEARCH'
export const VUEX_UI_HIDE_USER_SEARCH              = 'VUEX_UI_HIDE_USER_SEARCH'
export const VUEX_UI_SHOW_USER_SEARCH_MOBILE       = 'VUEX_UI_SHOW_USER_SEARCH_MOBILE'
export const VUEX_UI_HIDE_USER_SEARCH_MOBILE       = 'VUEX_UI_HIDE_USER_SEARCH_MOBILE'

export const VUEX_UI_SET_COMMENT_EDITOR_OPEN_STATE = 'VUEX_UI_SET_COMMENT_EDITOR_OPEN_STATE'
export const VUEX_UI_SHOW_REQUEST_ACCESS_OVERLAY   = 'VUEX_UI_SHOW_REQUEST_ACCESS_OVERLAY'
export const VUEX_UI_HIDE_REQUEST_ACCESS_OVERLAY   = 'VUEX_UI_HIDE_REQUEST_ACCESS_OVERLAY'
export const VUEX_UI_SHOW_QUICK_FILTER_OVERLAY     = 'VUEX_UI_SHOW_QUICK_FILTER_OVERLAY'
export const VUEX_UI_HIDE_QUICK_FILTER_OVERLAY     = 'VUEX_UI_HIDE_QUICK_FILTER_OVERLAY'

export const VUEX_UI_SHOW_MOBILE_DRAWER_RIGHT      = 'VUEX_UI_SHOW_MOBILE_DRAWER_RIGHT'
export const VUEX_UI_HIDE_MOBILE_DRAWER_RIGHT      = 'VUEX_UI_HIDE_MOBILE_DRAWER_RIGHT'

export const VUEX_UI_NAV_CHILDREN_OPEN             = 'VUEX_UI_NAV_CHILDREN_OPEN'

export const VUEX_UI_SHOW_GLOBAL_UPLOADER          = 'VUEX_UI_SHOW_GLOBAL_UPLOADER'
export const VUEX_UI_HIDE_GLOBAL_UPLOADER          = 'VUEX_UI_HIDE_GLOBAL_UPLOADER'
export const VUEX_UI_OPEN_GLOBAL_UPLOADER          = 'VUEX_UI_OPEN_GLOBAL_UPLOADER'
export const VUEX_UI_CLOSE_GLOBAL_UPLOADER         = 'VUEX_UI_CLOSE_GLOBAL_UPLOADER'

export const VUEX_UI_PROGRESS_COLUMNS              = ['On Hold', 'In Design', 'Comps', 'Revisions', 'Art Approved']

export const VUEX_UI_SHOW_JOB_PRINT_OVERLAY             = 'VUEX_UI_SHOW_JOB_PRINT_OVERLAY'
export const VUEX_UI_HIDE_JOB_PRINT_OVERLAY             = 'VUEX_UI_HIDE_JOB_PRINT_OVERLAY'
export const VUEX_UI_SET_ERROR_JOB_PRINT_OVERLAY        = 'VUEX_UI_SET_ERROR_JOB_PRINT_OVERLAY'

export const VUEX_UI_SHOW_EMAIL_ALL_OVERLAY        = 'VUEX_UI_SHOW_EMAIL_ALL_OVERLAY'
export const VUEX_UI_HIDE_EMAIL_ALL_OVERLAY        = 'VUEX_UI_HIDE_EMAIL_ALL_OVERLAY'
export const VUEX_UI_SEND_EMAIL_ALL                = 'VUEX_UI_SEND_EMAIL_ALL'

export const AVATAR_PLACEHOLDER_URL                = require('@/assets/images/avatar-placeholder.png')

export const VUE_UI_ERROR_MSGS = {
  EMAIL: {
    REQUIRED:     'Please enter an email address',
    INVALID:      'Please enter a valid email address',
  },
  PASSWORD: {
    MIN_LENGTH:   'The minium length for a password is:',
    REQUIRED:     'Please enter a password',
    NON_MATCHING: 'The entered passwords don\'t match',
  },
  ROUTE: {
    INVALID_PERMISSION: 'You don\'t have permssion to view this route',
  },
}

// Used to track open status of preview windows across in-place file updates
export const VUEX_UI_SET_PREVIEW_OPEN_STATUS          = 'VUEX_UI_SET_PREVIEW_OPEN_STATUS'
export const VUEX_UI_CLEAR_ALL_PREVIEW_OPEN_STATUSES  = 'VUEX_UI_CLEAR_ALL_PREVIEW_OPEN_STATUSES'

export const VUEX_MEMO_ITEM_MOBILE_DRAWER_INIT        = 'VUEX_MEMO_ITEM_MOBILE_DRAWER_INIT'